export enum VoteEnum {
    FOR = 'FOR',
    AGAINST = 'AGAINST',
    ABSTENTION = 'ABSTENTION'
}
